const STORAGE_LOGIN_KEY = '_fpl'
const STORAGE_SIGNUP_KEY = '_fps'
const STORAGE_RESET_KEY = '_fpr'
const STORAGE_CUSTOMIZATION_KEY = '_fpc'
const STORAGE_TRANSLATIONS_KEY = '_fpt'
const STORAGE_LANG_KEY = '_fpla'
const STARAGE_SUGGESTIONS_KEY = '_fpsu'
const MAX_VALID_STORAGE_MINUTE = 1000

const STATUS_RECOVERY_SUCCESS = 'ok'
const STATUS_RECOVERY_ERROR = 'ko'
const STATUS_EXISTS_WITH_DISCOUNT = 'discount'
const STATUS_EXISTS_WITHOUT_DISCOUNT = 'nodiscount'

const NULL_CARD_NUMBER = '0000000000000'
const EMAIL_TYPE = 'email'
const DNI_TYPE = 'dni'
const ENCRIPTION_SECRET = 'zoh4X8KHO26YGzkIFmmTs7Yv0UI8xbJjPmOWIj2sqPATbBL5tGV'

// Variables from FC2 config
const DEFAULT_LANGUAGE = 'es_es'
const LANGUAGE_OBJ_CONFIG = {
  es_es: 'es',
  'es-es': 'es',
  ca_es: 'ca',
  'ca-es': 'ca'
}

const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1300
}

export {
  STORAGE_LOGIN_KEY,
  MAX_VALID_STORAGE_MINUTE,
  STORAGE_SIGNUP_KEY,
  STORAGE_CUSTOMIZATION_KEY,
  STORAGE_TRANSLATIONS_KEY,
  STARAGE_SUGGESTIONS_KEY,
  STATUS_RECOVERY_SUCCESS,
  STATUS_RECOVERY_ERROR,
  STATUS_EXISTS_WITH_DISCOUNT,
  STATUS_EXISTS_WITHOUT_DISCOUNT,
  NULL_CARD_NUMBER,
  STORAGE_RESET_KEY,
  EMAIL_TYPE,
  DNI_TYPE,
  ENCRIPTION_SECRET,
  DEFAULT_LANGUAGE,
  STORAGE_LANG_KEY,
  LANGUAGE_OBJ_CONFIG,
  BREAKPOINTS
}
